import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/autenticacao`

    return {
        login(params) {
            return repository.post(`${baseUrl}/login`, params)
        },
        logout() {
            return repository.post(`${baseUrl}/logout`)
        },
        recovery(params) {
            return repository.post(`${baseUrl}/recovery`, params)
        },
        refresh() {
            return repository.post(`${baseUrl}/refresh`)
        },
    }
}